// Four 20 Pharma (Curaleaf)
export const FOUR20_STRAINS = [
  {
    id: "four20-gorilla-glue",
    name: "Gorilla Glue #4",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Chem Sis × Sour Dubb × Chocolate Diesel",
    thc: 22, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Ziemisty", "Diesel", "Orzechowy"],
    description: "Susz o silnym działaniu przeciwbólowym dzięki wysokiej zawartości THC, ale też przeciwzapalnym za co odpowiada dominujący w profilu terpenowym kariofilen. Pacjenci chwalą głęboki relaks fizyczny i wyraźne wyciszenie — odmiana szczególnie doceniana przy dolegliwościach bólowych i zaburzeniach snu. Zgłaszane jest mocne i długie działanie leku.",
    terpenes: { kariofilen: 40, mircen: 10, limonen: 7, humulen: 7 },
    dominantTerpene: "Kariofilen", packaging: "5g, 15g, 100g"
  },
  {
    id: "four20-gorilla-glue-25",
    name: "Gorilla Glue #4",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Chem Sis × Sour Dubb × Chocolate Diesel",
    thc: 25, cbd: 0.5,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Ziemisty", "Diesel", "Orzechowy"],
    description: "Susz o silnym działaniu przeciwbólowym dzięki wysokiej zawartości THC, ale też przeciwzapalnym za co odpowiada dominujący w profilu terpenowym kariofilen. Pacjenci chwalą głęboki relaks fizyczny i wyraźne wyciszenie — odmiana szczególnie doceniana przy dolegliwościach bólowych i zaburzeniach snu. Zgłaszane jest mocne i długie działanie leku.",
    terpenes: { kariofilen: 40, mircen: 10, limonen: 7, humulen: 7 },
    dominantTerpene: "Kariofilen", packaging: "5g, 15g, 100g",
    dateAdded: "2026-11-04T10:00:00", isNew: true
  },
  {
    id: "four20-gmo-garlic-cookies",
    name: "GMO (Garlic Cookies)",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Chem D × Girl Scout Cookies",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Czosnek", "Cebula"],
    description: "Susz wykazuje właściwości przeciwzapalne, dzięki obecności mircenu, dodatkowo poprawiając jakość snu, działając uspokajająco i sedatywnie. Ponadto susz zmniejsza napięcie mięśniowe, wykazuje właściwości antyoksydacyjne i wykazuje się wyjątkowo długim działaniem.",
    terpenes: { farnezen: 25, mircen: 20, kariofilen: 19, limonen: 16, humulen: 8 },
    dominantTerpene: "Farnezen", packaging: "5g, 15g, 100g"
  },
  {
    id: "four20-gastro-pop-27",
    name: "Gastro Pop",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Apples & Bananas × Grape Gasoline",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Owocowy", "Diesel", "Winogrona"],
    description: "Gastro Pop to hybryda z przewagą indici od Four 20 Pharma o zawartości THC 27%. Dominujący mircen odpowiada za głęboki relaks mięśniowy, działanie sedatywne i poprawę jakości snu. Ocymen wnosi działanie przeciwzapalne, potęgowane przez kariofilen, który jako jedyny terpen bezpośrednio z receptorami CB2. Linalol wzmacnia efekt uspokajający i przeciwlękowy, bez zbędnej sedacji.",
    terpenes: { mircen: 49, linalol: 11, ocymen: 13, kariofilen: 9, selinadien: 8 },
    dominantTerpene: "Mircen", packaging: "5g, 15g, 100g",
    dateAdded: "2026-07-31"
  },
  {
    id: "four20-masterpiece-27",
    name: "Masterpiece",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Cap Junky × Platinum",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Kwaśny", "Kwiatowy"],
    description: "Hybryda z dominantą sativy z pierwszym w profilu terpinolenem, nadającym charakterystyczną, cytrusową woń, typową dla suszy o charakterze sativa (którą dodatkowo wzmaga limonen). Ten drugi wykazuje właściwości poprawiające nastrój i przeciwdepresyjne. Mircen zmniejsza napięcie mięśniowe i powoduje uczucie relaksacji, a kariofilen działa przeciwzapalnie i synergistycznie z limonenem, poprawia nastrój.",
    terpenes: { limonen: 30, mircen: 14, linalol: 9, kariofilen: 6, bulnesol: 3 },
    dominantTerpene: "Limonen", packaging: "5g, 15g, 100g",
    dateAdded: "2026-07-31"
  },
  {
    id: "four20-frozen-lemon-mints-27",
    name: "Frozen Lemon Mints",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Sativa",
    lineage: "Cap's Frozen Lemon × Kush Mints #11",
    thc: 27, cbd: 0.4,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Miętowy", "Diesel", "Kremowy"],
    description: "Hybryda, z dominantą sativy, dzięki dominującemu w profilu terpenowym terpinolenowi poprawia koncentrację i ułatwia skupienie oraz działa aktywizująco, co potęguje limonen, trzeci najbardziej obfity terpen w tym suszu. Limonen wykazuje dodatkowo działanie przeciwdepresyjne, podobnie do kariofilenu, a mircen powoduje zmniejszenie napięcia mięśniowego i uczucie relaksacji (bez nadmiernej sedacji).",
    terpenes: { terpinolen: 36, kariofilen: 13, limonen: 10, mircen: 9, linalol: 6 },
    dominantTerpene: "Terpinolen", packaging: "5g, 15g, 100g",
    dateAdded: "2026-08-18"
  },
  {
    id: "four20-frozen-lemon-mints-25",
    name: "Frozen Lemon Mints",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Sativa",
    lineage: "Cap's Frozen Lemon × Kush Mints #11",
    thc: 25, cbd: 0.4,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Miętowy", "Diesel", "Kremowy"],
    description: "Hybryda, z dominantą sativy, dzięki dominującemu w profilu terpenowym terpinolenowi poprawia koncentrację i ułatwia skupienie oraz działa aktywizująco, co potęguje limonen, trzeci najbardziej obfity terpen w tym suszu. Limonen wykazuje dodatkowo działanie przeciwdepresyjne, podobnie do kariofilenu, a mircen powoduje zmniejszenie napięcia mięśniowego i uczucie relaksacji (bez nadmiernej sedacji).",
    terpenes: { terpinolen: 36, kariofilen: 13, limonen: 10, mircen: 9, linalol: 6 },
    dominantTerpene: "Terpinolen", packaging: "5g, 15g, 100g",
    dateAdded: "2026-11-04T10:00:00", isNew: true
  },
  {
    id: "four20-mac-1-22",
    name: "Mac 1",
    producer: "Four 20 Pharma (Curaleaf)",
    country: "Kanada",
    genetics: "Hybryda/Indica",
    lineage: "Alien Cookies F2 × Miracle 15",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kwiatowy", "Owocowy", "Pieprzowy", "Ziołowy"],
    description: "Rzadki, dominujący w profilu terpenowym farnezen nadaje suszowi kwiatowo-owocową woń. Kariofilen działa przeciwbólowo i przeciwzapalnie, ale też poprawia nastrój, synergistycznie do limonenu. Ceniony przez Pacjentów za wszechstronne działanie: pobudzenie, rozluźnienie mięśni, analgezja i wyciszenie w jednym.",
    terpenes: { farnezen: 27, limonen: 20, kariofilen: 11, pinen: 8, linalol: 7 },
    dominantTerpene: "Farnezen", packaging: "5g, 15g, 100g"
  }
];